export default __webpack_public_path__ + "static/media/software-eps.2c92bc3d.png";